"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Textarea;

var _TextareaModule = _interopRequireDefault(require("../../assets/styles/components/Textarea.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Textarea(_ref) {
  let {
    placeholder,
    maxLength,
    styling = {},
    disabled,
    size = "default",
    value,
    isResizableVertically = false,
    isResizableHorizontally = false,
    onChange: _onChange,
    readOnly,
    rows = 2
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
    placeholder: placeholder,
    maxLength: maxLength,
    style: styling,
    rows: rows,
    readOnly: readOnly,
    disabled: disabled,
    className: "".concat(_TextareaModule.default.textarea, " \n                ").concat(size === "mini" ? _TextareaModule.default.size_mini : size === "compact" ? _TextareaModule.default.size_compact : size === "default" ? _TextareaModule.default.size_default : size === "large" ? _TextareaModule.default.size_large : _TextareaModule.default.size_default, "\n                ").concat(isResizableVertically ? _TextareaModule.default.resizable_vertically_true : _TextareaModule.default.resizable_vertically_false, "\n                ").concat(isResizableHorizontally ? _TextareaModule.default.resizable_horizontally_true : _TextareaModule.default.resizable_horizontally_false, "\n            "),
    value: value,
    onChange: e => {
      _onChange(e);
    }
  });
}